import { useParams } from 'react-router-dom';

import {
  useGetForm,
  useGetFormAttachments,
  useGetFormsOptions,
} from 'api/forms';
import {
  DetailsViewLayout as Layout,
  DetailsViewLayoutContent as LayoutContent,
  DetailsViewLayoutHeader as LayoutHeader,
  DetailsViewLayoutMain as LayoutMain,
  DetailsViewLayoutSidebar as LayoutSidebar,
  NoAccess,
} from 'components/shared';

import { Box, Flex, Loader } from '@mantine/core';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { FormEditContextProvider } from './context';
import { useGetTemplate } from '../../../api/templates';
import { MockExtForm } from './MockExtForm';
import { useGetCurrentBoard } from '../../../api/boards';

export const FormEdit = () => {
  const { formId } = useParams();
  const { board, isCurrentBoardLoading } = useGetCurrentBoard();
  const hasBoardTemplateFeature = board?.canAccessTemplateCreator || false;

  const { data: form, isLoading: isFormLoading } = useGetForm(
    { id: formId as string },
    { enabled: formId !== undefined },
  );
  const {
    data: attachments,
    isLoading: isAttachmentsLoading,
    refetch: refetchAttachment,
  } = useGetFormAttachments(
    { formId: formId as string },
    { enabled: formId !== undefined },
  );
  const { data: formsOptions, isLoading: isFormsOptionsLoading } =
    useGetFormsOptions();

  const { data: template, isLoading: isTemplateLoading } = useGetTemplate(
    {
      pathParams: { templateId: form?.template.id! },
    },
    { enabled: !!form?.template?.id },
  );

  const isLoading =
    isFormLoading ||
    isAttachmentsLoading ||
    isFormsOptionsLoading ||
    isTemplateLoading;
  const dataComplete = form && attachments && formsOptions && template;

  if (isCurrentBoardLoading) {
    return (
      <Flex justify="center" align="center" h="100%">
        <Loader />
      </Flex>
    );
  }

  if (!hasBoardTemplateFeature) {
    return <NoAccess />;
  }

  return (
    <Layout displayLoader={isLoading}>
      {dataComplete && (
        <FormEditContextProvider
          form={form}
          attachments={attachments}
          refetchAttachment={refetchAttachment}
          formsOptions={formsOptions}
          template={template}
        >
          <LayoutHeader>
            <Header />
          </LayoutHeader>
          <LayoutContent>
            <LayoutMain
              sx={{ display: 'flex', alignItems: 'stretch', overflow: 'auto' }}
            >
              <Box sx={{ border: 0, flex: 1 }}>
                <MockExtForm />
              </Box>
            </LayoutMain>
            <LayoutSidebar>
              <Sidebar />
            </LayoutSidebar>
          </LayoutContent>
        </FormEditContextProvider>
      )}
    </Layout>
  );
};
